// @flow
import React from 'react';

import { withHelmet } from 'infrastructure/seo/Helmet';
import Breadcrumb from 'components/fragments/Breadcrumb';
import type { FilArianneItemType } from 'types/Partenaires';

export type StateProps = {
  filarianne: FilArianneItemType[],
  title: string,
  featured_media: {
    src: string,
    legend: string
  },
  meta_description: string,
  meta_title: string
};

type Props = {
  title: string,
  withSubMenu: boolean,
  className?: string
} & StateProps;

const HOME_LINK = { name: 'Accueil', to: 'home' };
const PARTENAIRES_PAGE_DEFAULT_LINK = { name: 'Partenaires', to: '../ligue/partenaires-mecenes' };

const PagePartenaireHeader = (props: Props) => {
  const { filarianne, title } = props;

  let breadcrumbData = [...filarianne, title];
  // in case no partenaire template has been found since it has not been associated with partner page
  // can't use partenaires_page from settings either since it is also created with partenaire template
  if (!filarianne || !filarianne.length) {
    breadcrumbData = [HOME_LINK, PARTENAIRES_PAGE_DEFAULT_LINK, title];
  }

  return (
    <div className="col col-lg-8on9 mb-3">
      <Breadcrumb breadcrumbStyle="mt-4" elements={breadcrumbData} isPagePartenaireHeader />
      <h1 className="article_title mt-6">{title}</h1>
    </div>
  );
};

export default withHelmet(PagePartenaireHeader)((Helmet, pageProps) => {
  const ogimage = pageProps.featured_media.src;
  const ogimagetitle = pageProps.featured_media.title;
  return (
    <Helmet>
      <title>{pageProps.meta_title}</title>
      <meta name={'description'} content={`${pageProps.meta_description.slice(0, 197)}...`} />
      <meta property={'og:url'} content={window.location.href} />
      <meta property={'og:title'} content={pageProps.meta_title} />
      <meta property={'og:description'} content={`${pageProps.meta_description.slice(0, 197)}...`} />
      {ogimage && <meta property={'og:image'} content={ogimage} />}
      {ogimage && <meta property={'og:image:url'} content={ogimage} />}
      {ogimage && ogimagetitle && <meta property={'og:image:title'} content={ogimagetitle} />}
    </Helmet>
  );
});
